module.exports = __webpack_public_path__ + "static/media/icono_musico.58de193a.svg";